import { render, staticRenderFns } from "./district-create.vue?vue&type=template&id=224463ca&"
import script from "./district-create.vue?vue&type=script&lang=js&"
export * from "./district-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports